import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { StripeForm } from './form';
export const UpdatePaymentMethodModalContent = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    paymentId = _ref.paymentId;
  const store = useStore();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    clientSecret = _useState2[0],
    setClientSecret = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isStripeLoad = _useState4[0],
    setIsStripeLoad = _useState4[1];
  const asyncDataLoading = async () => {
    var _setupIntentResp$resp;
    const publicKeyResp = await store.payment.getPublicKeyAsync.run();
    if (!publicKeyResp || !publicKeyResp.isSuccessful) return;
    const setupIntentResp = await store.payment.createSetupIntentWithPaymentMethodReplacementAsync.run({
      oldPaymentMethodId: paymentId
    });
    if (!setupIntentResp || !setupIntentResp.isSuccessful) return;
    setClientSecret(setupIntentResp === null || setupIntentResp === void 0 || (_setupIntentResp$resp = setupIntentResp.response) === null || _setupIntentResp$resp === void 0 ? void 0 : _setupIntentResp$resp.clientSecret);
    setIsStripeLoad(true);
  };
  useEffect(() => {
    asyncDataLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isStripeLoad && clientSecret && /*#__PURE__*/React.createElement(Elements, {
    options: {
      clientSecret
    },
    stripe: loadStripe(store.payment.publicKey)
  }, /*#__PURE__*/React.createElement(StripeForm, {
    handleModalClose: handleModalClose
  })));
});